export const FIXED_TENURE = 'tenure';
export const FIXED_PAYMENT = 'payment';
export const MANUAL_ENTRY = 'manual';
